"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _tokens = require("../../../tokens");

var _validations = require("../../_utils/validations");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  flex-basis: ", "%;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  flex-wrap: no-wrap;\n  align-items: ", ";\n  justify-content: ", ";\n  > * {\n    flex: ", ";\n    margin-right: ", ";\n  }\n  > *:last-child {\n    margin-right: 0;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var alignItems = {
  top: 'flex-start',
  center: 'center',
  bottom: 'flex-end'
};
var justifyContent = {
  fill: 'space-between',
  left: 'flex-start',
  right: 'flex-end'
};

var StyledStack = _styledComponents["default"].div(_templateObject(), function (props) {
  return alignItems[props.alignVertical];
}, function (props) {
  return justifyContent[props.align];
}, function (props) {
  return props.align === 'fill' ? 1 : 'none';
}, function (props) {
  return props.align === 'fill' ? _tokens.spacing.xsmall : 0;
});

var StackedItem = _styledComponents["default"].div(_templateObject2(), function (props) {
  return props.width;
});

var Stack = function Stack(props) {
  var children;

  if (props.align === 'fill') {
    children = _react["default"].Children.map(props.children, function (child, index) {
      var width = 0;
      if (props.widths) width = "".concat(props.widths[index]) || 0;
      return _react["default"].createElement(StackedItem, {
        width: width
      }, child);
    });
  } else {
    children = props.children;
  }

  return _react["default"].createElement(StyledStack, props, children);
};

Stack.propTypes = {
  align: _propTypes["default"].oneOf(['fill', 'left', 'right']),
  alignVertical: _propTypes["default"].oneOf(['top', 'center', 'bottom']),
  widths: _propTypes["default"].arrayOf(_propTypes["default"].number),
  _sum: function _sum(props) {
    return (0, _validations.sumOfElements)(props.widths, 100);
  },
  _numberOfValues: function _numberOfValues(props) {
    return (0, _validations.numberOfValues)(props.widths, _react["default"].Children.count(props.children));
  }
};
Stack.defaultProps = {
  align: 'fill',
  alignVertical: 'center'
};
var _default = Stack;
exports["default"] = _default;